import React from "react";

// Shipping costs by country in KSh
export const SHIPPING_RATES = {
  "Afghanistan": 3200,
"Albania": 2650,
"Algeria": 2050,
"Andorra": 2650,
"Angola": 1750,
"Antigua and Barbuda": 3650,
"Argentina": 3950,
"Armenia": 2750,
"Australia": 4400,
"Austria": 2650,
"Azerbaijan": 2750,
"Bahamas": 3750,
"Bahrain": 2650,
"Bangladesh": 3200,
"Barbados": 3750,
"Belarus": 2850,
"Belgium": 2650,
"Belize": 3750,
"Benin": 1750,
"Bhutan": 3100,
"Bolivia": 3950,
"Bosnia and Herzegovina": 2750,
"Botswana": 1750,
"Brazil": 3950,
"Brunei": 3200,
"Bulgaria": 2750,
"Burkina Faso": 1750,
"Burundi": 1450,
"Cabo Verde": 1850,
"Cambodia": 3100,
"Cameroon": 1750,
"Canada": 3750,
"Central African Republic": 1750,
"Chad": 1750,
"Chile": 3950,
"China": 3100,
"Colombia": 3950,
"Comoros": 1650,
"Congo (Congo-Brazzaville)": 1750,
"Costa Rica": 3750,
"Croatia": 2650,
"Cuba": 3950,
"Cyprus": 2750,
"Czech Republic": 2750,
"Denmark": 2650,
"Djibouti": 1650,
"Dominica": 3750,
"Dominican Republic": 3750,
"Ecuador": 3950,
"Egypt": 2050,
"El Salvador": 3750,
"Equatorial Guinea": 1750,
"Eritrea": 1650,
"Estonia": 2750,
"Eswatini": 1650,
"Ethiopia": 1450,
"Fiji": 4300,
"Finland": 2650,
"France": 2650,
"Gabon": 1750,
"Gambia": 1750,
"Georgia": 2750,
"Germany": 2650,
"Ghana": 1750,
"Greece": 2650,
"Grenada": 3750,
"Guatemala": 3750,
"Guinea": 1750,
"Guinea-Bissau": 1750,
"Guyana": 3950,
"Haiti": 3750,
"Honduras": 3750,
"Hungary": 2650,
"Iceland": 2750,
"India": 3200,
"Indonesia": 3200,
"Iran": 2750,
"Iraq": 2650,
"Ireland": 2550,
"Israel": 2650,
"Italy": 2650,
"Jamaica": 3750,
"Japan": 3100,
"Jordan": 2650,
"Kazakhstan": 2850,
"Kenya": 150,
"Kiribati": 4400,
"Kuwait": 2650,
"Kyrgyzstan": 2850,
"Laos": 3200,
"Latvia": 2750,
"Lebanon": 2650,
"Lesotho": 1650,
"Liberia": 1750,
"Libya": 2050,
"Liechtenstein": 2650,
"Lithuania": 2750,
"Luxembourg": 2650,
"Madagascar": 1650,
"Malawi": 1650,
"Malaysia": 3200,
"Maldives": 3200,
"Mali": 1750,
"Malta": 2650,
"Marshall Islands": 4400,
"Mauritania": 1750,
"Mauritius": 1650,
"Mexico": 3750,
"Micronesia": 4400,
"Moldova": 2750,
"Monaco": 2650,
"Mongolia": 3200,
"Montenegro": 2750,
"Morocco": 2050,
"Mozambique": 1650,
"Myanmar": 3200,
"Namibia": 1650,
"Nauru": 4400,
"Nepal": 3200,
"Netherlands": 2650,
"New Zealand": 4500,
"Nicaragua": 3750,
"Niger": 1750,
"Nigeria": 1750,
"North Korea": 3300,
"North Macedonia": 2750,
"Norway": 2650,
"Oman": 2650,
"Pakistan": 3200,
"Palau": 4400,
"Palestine State": 2650,
"Panama": 3750,
"Papua New Guinea": 4300,
"Paraguay": 3950,
"Peru": 3950,
"Philippines": 3200,
"Poland": 2850,
"Portugal": 2650,
"Qatar": 2650,
"Romania": 2750,
"Russia": 2850,
"Rwanda": 1450,
"Saint Kitts and Nevis": 3750,
"Saint Lucia": 3750,
"Saint Vincent and the Grenadines": 3750,
"Samoa": 4400,
"San Marino": 2650,
"Sao Tome and Principe": 1750,
"Saudi Arabia": 2650,
"Senegal": 1750,
"Serbia": 2750,
"Seychelles": 1650,
"Sierra Leone": 1750,
"Singapore": 3200,
"Slovakia": 2750,
"Slovenia": 2650,
"Solomon Islands": 4400,
"Somalia": 1650,
"South Africa": 1650,
"South Korea": 3100,
"South Sudan": 1450,
"Spain": 2650,
"Sri Lanka": 3200,
"Sudan": 1750,
"Suriname": 3950,
"Sweden": 2650,
"Switzerland": 2650,
"Syria": 2650,
"Taiwan": 3100,
"Tajikistan": 2850,
"Tanzania": 1450,
"Thailand": 3200,
"Timor-Leste": 4300,
"Togo": 1750,
"Tonga": 4400,
"Trinidad and Tobago": 3750,
"Tunisia": 2050,
"Turkey": 2750,
"Turkmenistan": 2850,
"Tuvalu": 4400,
"Uganda": 1450,
"Ukraine": 2750,
"United Arab Emirates": 2650,
"United Kingdom": 2550,
"United States of America": 3650,
"Uruguay": 3950,
"Uzbekistan": 2850,
"Vanuatu": 4400,
"Vatican City": 2650,
"Venezuela": 3950,
"Vietnam": 3200,
"Yemen": 2650,
"Zambia": 1650,
"Zimbabwe": 1650
};

// Default shipping cost if country not found
const DEFAULT_SHIPPING_COST = 3000;

/**
 * Find country in shipping rates regardless of case
 * @param {string} searchCountry - The country to search for
 * @returns {string|null} - The matched country key or null if not found
 */
const findCountryKey = (searchCountry) => {
  if (!searchCountry) return null;
  
  // Normalize the search string
  const searchNormalized = searchCountry.trim().toLowerCase();
  
  // Find first matching country (case insensitive)
  const countryKey = Object.keys(SHIPPING_RATES).find(country => 
    country.toLowerCase() === searchNormalized
  );
  
  return countryKey;
};

/**
 * Calculate shipping cost based on the customer's country
 * @param {string} country - The shipping destination country
 * @param {number} orderValue - The total value of items in the order (not used but kept for compatibility)
 * @returns {number} - The calculated shipping cost
 */
export const calculateShippingCost = (country, orderValue) => {
  if (!country) return DEFAULT_SHIPPING_COST;
  
  // Try to find an exact match regardless of case
  const countryKey = findCountryKey(country);
  
  // Return the shipping rate if found, otherwise default
  return countryKey ? SHIPPING_RATES[countryKey] : DEFAULT_SHIPPING_COST;
};

const ShippingCost = ({ country, orderValue, display = true }) => {
  const countryKey = findCountryKey(country);
  const shippingCost = calculateShippingCost(country, orderValue);
  
  if (!display) {
    return null;
  }
  
  return (
    <div className="shipping-cost-info">
      <p>Shipping to <strong>{countryKey || country}</strong>: Ksh {shippingCost}</p>
    </div>
  );
};

export default ShippingCost;